var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFtmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1969FF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fantom-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_00000106136133819648777900000000593517372727848117_",
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M413.9,140.1c14.8-7.8,37.4-7.8,52.3,0L617.6,220c8.9,4.7,13.9,11.7,14.7,19h0.1v401.4 c-0.2,7.9-5.2,15.8-14.9,20.9l-151.5,79.9c-14.8,7.8-37.4,7.8-52.3,0l-151.5-79.9c-9.7-5.1-14.3-13-14.6-20.9c0-0.8,0-1.5,0-2 l0-396.7c0-0.6,0-1.1,0-1.7l0-1h0.1c0.7-7.3,5.4-14.2,14.5-19L413.9,140.1z M608.4,462.1l-142.3,75.3c-14.8,7.8-37.4,7.8-52.2,0 l-142-75.1v176.8l142,74.7c8.4,4.5,17.1,8.9,25.6,9.1l0.5,0c8.5,0,16.7-4.3,25.1-8.4l143.3-76V462.1z M224.1,631.7 c0,15.4,1.8,25.5,5.3,32.6c2.9,5.9,7.3,10.4,15.3,15.9l0.5,0.3c1.8,1.2,3.7,2.4,6,3.9l2.8,1.7l8.5,5.2l-12.2,20.4l-9.5-5.8l-1.6-1 c-2.8-1.7-5-3.2-7.2-4.6c-22.8-15.5-31.3-32.4-31.4-67.5l0-1.1H224.1z M428.6,355.4c-1.1,0.4-2.1,0.8-3.1,1.3l-151.2,80.1 c-0.2,0.1-0.3,0.2-0.5,0.2l-0.1,0.1l0.2,0.1l0.3,0.2l151.2,80.1c0.9,0.5,2,0.9,3.1,1.3V355.4z M452.7,355.4v163.5 c1.1-0.4,2.1-0.8,3.1-1.3L607,437.5c0.2-0.1,0.3-0.2,0.5-0.2l0.1-0.1l-0.2-0.1l-0.3-0.2l-151.2-80.1 C454.8,356.2,453.8,355.8,452.7,355.4z M608.4,267.6l-136,71.4l136,71.4V267.6z M271.9,267.6v142.9l136-71.4L271.9,267.6z  M455.6,161.5c-7.9-4.2-22.1-4.2-30,0l-151.4,80c-0.2,0.1-0.3,0.2-0.5,0.2l-0.1,0.1l0.2,0.1l0.3,0.2l151.4,80 c7.9,4.2,22.1,4.2,30,0l151.4-80c0.2-0.1,0.3-0.2,0.5-0.2l0.1-0.1l-0.2-0.1l-0.3-0.2L455.6,161.5z M631,169.5l9.5,5.8l1.6,1 c2.8,1.7,5,3.2,7.2,4.6c22.8,15.5,31.3,32.4,31.4,67.5l0,1.1h-23.6c0-15.4-1.8-25.5-5.3-32.6c-2.9-5.9-7.3-10.4-15.3-15.9 l-0.5-0.3c-1.8-1.2-3.7-2.4-6-3.9l-2.8-1.7l-8.5-5.2L631,169.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtmIcon);
export default __webpack_public_path__ + "static/media/ftm_icon.e8e32bbf389f568d4230bc8885ec8198.svg";
export { ForwardRef as ReactComponent };